import { render, staticRenderFns } from "./AutoVillageLogo.vue?vue&type=template&id=073b8429&scoped=true"
import script from "./AutoVillageLogo.vue?vue&type=script&lang=js"
export * from "./AutoVillageLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073b8429",
  null
  
)

export default component.exports